module.exports = __webpack_public_path__ + "static/python-patterns-59cfec72db21e678101c5a55088adf8b.jpg";